import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.iterator";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es7.object.values";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.number.constructor";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations, mapState } from 'vuex';
import ApiService from '@/services/apiService';
import iotFetchMixin from './iotFetchMixin';
import AddressLatLongMixin from '@/components/core/addressLatLongMixin';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import unset from 'lodash/unset';
var ITEMS_PER_PAGE = 5;
var defaultTableOptions = {
  page: 1,
  itemsPerPage: ITEMS_PER_PAGE
};
var vDeviceLookupMultipleMatches = 'MULTIPLE_MATCHES';
export default {
  name: 'CoreDtwinDuplicateVirtualDevices',
  mixins: [iotFetchMixin, AddressLatLongMixin],
  props: {
    orgTwin: {
      type: Object,
      required: true
    },
    orgTwinStates: {
      type: Array,
      required: true
    },
    twinCopiesData: {
      type: Array,
      required: true
    },
    statePickerMode: {
      type: String,
      required: true
    },
    errornousParentId: {
      type: Number,
      required: true
    },
    bridgeConfigs: {
      type: Array,
      required: true
    },
    globalParentTwin: {
      type: Object,
      required: true
    },
    // eslint-disable-next-line vue/require-prop-types
    globalParentId: {
      // is either false or a number
      required: true
    },
    loadingStates: {
      type: Boolean,
      required: true
    },
    pickableStates: {
      type: Array,
      required: true
    },
    metaInfoToggles: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      vDeviceFetchMapping: {
        // map the searched vdevice findById request here
        vdevice: {},
        // map the states-fetch-requests for the vdevice above here, to match with orgState
        vdeviceStates: {},
        // map the get-request for the original `stateId` of the org vdevice here
        vdeviceOrgState: {}
      },
      tableOptions: _objectSpread({}, defaultTableOptions),
      showOptionsMenus: {},
      disableFetchOnCreatedMixin: true,
      itemsPerPage: ITEMS_PER_PAGE
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    titlePlaceholder: function titlePlaceholder() {
      return "".concat(this.orgTwin.title, " copy [X]");
    },
    tableFooterProps: function tableFooterProps() {
      return {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [3]
      };
    },
    noSourceType: function noSourceType() {
      return "".concat(this.$i18n_t('DigitalTwin.DigitalTwin.states.copy.sourceType'), ": ").concat(this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.none'));
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    get: get,
    setCurrentTablePage: function setCurrentTablePage(value) {
      this.tableOptions.page = value;
    },
    setIotHubEuiFromOriginalState: function setIotHubEuiFromOriginalState(state, pickableState) {
      var _this = this;

      this.fetchIotHubDeviceEui(pickableState).then(function (finalEui) {
        if (finalEui) {
          _this.vModelForState(state).eui = finalEui;

          _this.$emit('cloneOrgTwinStates');
        }
      }).catch(function (error) {
        console.error(error);
      });
    },
    setVirtualDeviceExternalIdFromOriginalState: function setVirtualDeviceExternalIdFromOriginalState(state, pickableState) {
      var _this2 = this;

      this.fetchVirtualDeviceExternalId(pickableState).then(function (externalId) {
        if (externalId) {
          _this2.vModelForState(state).vdExternalId = externalId;

          _this2.$emit('cloneOrgTwinStates');
        }
      }).catch(function (error) {
        console.error(error);
      });
    },
    pickableTargetStates: function pickableTargetStates(twin) {
      return this.pickableStates.map(function (orgState) {
        return twin.states.find(function (s) {
          return s.id === orgState.id;
        });
      });
    },
    toggleStateBindingType: function toggleStateBindingType(matchingState, orgState) {
      var bindingType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'none';
      var cloneOriginalStates = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      if (matchingState.properties.binding.type === bindingType) {
        matchingState.properties.binding.type = orgState.properties.binding.type;
      } else {
        unset(matchingState, 'properties.binding.options.virtualDevice.vDeviceId');
        matchingState.properties.binding.type = bindingType; // a little hacky, but the v-model needs to bind to something,
        // so the display-text of "disabled" states is also set to vdExternalId of a target-model in vModelForState
        // this is not modifiable and just for output

        var targetProp = 'vdExternalId';

        if (orgState.properties.binding.type.startsWith('iothub')) {
          targetProp = 'eui';
        }

        matchingState.properties[targetProp] = bindingType === 'none' ? this.noSourceType : this.$i18n_t('DigitalTwin.DigitalTwin.copy.noStateCopy');
      }

      if (cloneOriginalStates) {
        this.$emit('cloneOrgTwinStates');
      }
    },
    matchedState: function matchedState(item, orgState) {
      return item.states.find(function (s) {
        return s.id === orgState.id;
      });
    },
    vModelForState: function vModelForState(matchingState) {
      if (matchingState.properties.binding.type.startsWith('virtual-device')) {
        return matchingState.properties.binding.options.virtualDevice;
      }

      if (matchingState.properties.binding.type.startsWith('iothub')) {
        return matchingState.properties.binding.options;
      }

      return matchingState.properties;
    },
    isLoadingStateData: function isLoadingStateData(matchingState) {
      if (matchingState.properties.binding.type.startsWith('virtual-device')) {
        return !!matchingState.properties.binding.options.virtualDevice.vdExternalId && !matchingState.properties.binding.options.virtualDevice.vDeviceKey;
      }

      if (matchingState.properties.binding.type.startsWith('iothub')) {
        return !!matchingState.properties.binding.options.identifier;
      }

      return false;
    },
    prependIconForState: function prependIconForState(matchingState) {
      if (matchingState.properties.binding.type.startsWith('virtual-device')) {
        return 'fa-sensor-on';
      }

      if (matchingState.properties.binding.type.startsWith('iothub')) {
        return 'fa-server';
      }

      return matchingState.properties.binding.type === 'none' ? 'fa-save' : 'fa-ban';
    },
    rulesForState: function rulesForState(matchingState) {
      var _this3 = this;

      if (!matchingState.properties.binding.type.startsWith('virtual-device') && !matchingState.properties.binding.type.startsWith('iothub')) {
        return [];
      }

      if (matchingState.properties.binding.type.startsWith('iothub')) {
        return this.euiRules;
      } // do not mark the state as invalid (in the UI!) until the state-get request was completed,
      // with a find or a 404


      return [function (v) {
        return !v && !matchingState.deviceTitle || !!v || _this3.$i18n_t('Common.fieldRequired');
      }, function (v) {
        return !v || matchingState.deviceTitle === undefined || !!matchingState.deviceTitle && !!matchingState.properties.binding.options.virtualDevice.vDeviceKey || _this3.$i18n_t('Error.DTWIN_STATE_NOT_FOUND');
      }];
    },
    hintForState: function hintForState(matchingState) {
      if (!matchingState.properties.binding.type.startsWith('virtual-device')) {
        return null;
      }

      if (matchingState.deviceTitle && matchingState.properties.binding.options.virtualDevice.vDeviceKey) {
        return "".concat(matchingState.deviceTitle, " - ").concat(matchingState.properties.binding.options.virtualDevice.vDeviceKey);
      }

      return null;
    },
    twinParentFilter: function twinParentFilter(twin) {
      return !get(twin, 'properties.disabled');
    },
    updateTwinsParents: function updateTwinsParents(parentTwin) {
      var _this4 = this;

      this.twinCopiesData.forEach(function (twin) {
        if (_this4.$refs["twin-finder-".concat(twin.id)]) {
          _this4.$refs["twin-finder-".concat(twin.id)].digitalTwin = null;
        }

        twin.parentId = parentTwin.id;
      });
    },
    handleCoordinateChange: function handleCoordinateChange(twin) {
      this.handleParsingCoordinates(twin.coordinates.coordinates);
    },
    fetchOptionsFromVDState: function fetchOptionsFromVDState(vdState) {
      var fetchOptions = {
        id: vdState.properties.binding.options.virtualDevice.vdExternalId,
        stateId: vdState.properties.binding.options.virtualDevice.stateId
      };

      if (vdState.properties.binding.type === 'virtual-device-aggregate') {
        // for aggregate-states, inside the UI only verify the first wired state
        // the rest has to be done in the BE for simplicity...
        fetchOptions.stateId = get(vdState, 'properties.binding.options.virtualDevice.stateIds[0]');
      }

      return fetchOptions;
    },
    fetchVirtualDeviceExternalId: function fetchVirtualDeviceExternalId(virtualDeviceState) {
      var _this5 = this;

      var deviceId = virtualDeviceState.properties.binding.options.virtualDevice.id;
      var foundMapping = Object.values(this.vDeviceFetchMapping).find(function (mapping) {
        return mapping.id === deviceId;
      });

      if (foundMapping) {
        var externalId = get(foundMapping, 'properties.bridge.deviceData.device_id');
        return Promise.resolve(externalId);
      }

      return ApiService.virtualDeviceGet(this, deviceId, 'bare').then(function (res) {
        var externalId = get(res, 'properties.bridge.deviceData.device_id');

        if (externalId) {
          _this5.vDeviceFetchMapping['vdevice'][externalId] = res;
        }

        return externalId;
      }).catch(function () {
        return null;
      });
    },
    fetchVirtualDeviceData: function fetchVirtualDeviceData(state, twin) {
      var _this6 = this;

      var cloneOriginalStates = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (!get(state, 'properties.binding.options.virtualDevice.vdExternalId')) {
        return;
      }

      state.deviceTitle = null;
      var fetchOptions = this.fetchOptionsFromVDState(state);
      return this.fetchVirtualDeviceDataDetails(fetchOptions).then(function (details) {
        state.properties.binding.options.virtualDevice = _objectSpread(_objectSpread({}, state.properties.binding.options.virtualDevice), {}, {
          vDeviceStateId: details.stateId,
          vDeviceId: details.id,
          vDeviceKey: details.key
        }); // if there are multiple matches for the same device_id, set this states' source to `none`

        if (details.id === vDeviceLookupMultipleMatches) {
          _this6.toggleStateBindingType(state, state, 'none', cloneOriginalStates);
        }

        state.deviceTitle = details.title;

        if (twin && cloneOriginalStates) {
          twin.states = cloneDeep(twin.states);
        }

        if (cloneOriginalStates) {
          _this6.$emit('cloneOrgTwinStates');
        }
      });
    },
    fetchVirtualDeviceDataDetails: function () {
      var _fetchVirtualDeviceDataDetails = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(virtualDeviceOptions) {
        var _this7 = this;

        var promisesPhase1;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // in the first version, one would search for the VD-id directly,
                // so both the VD-details AND the states of the VD could be requested in one go
                // now, the external-id is entered and that has to be resolved first, so this runs in 2 phases:
                //
                // I) request the states of the original VD & make a search for devices with the external-id
                // II) if there is a unique match for a VD (phase 1 does noto allow multiple matches)
                //      then proceed by fetching the states on the target/matched VD as well
                promisesPhase1 = [];

                if (this.vDeviceFetchMapping['vdevice'][virtualDeviceOptions.id]) {
                  promisesPhase1.push(Promise.resolve(this.vDeviceFetchMapping['vdevice'][virtualDeviceOptions.id]));
                } else {
                  promisesPhase1.push( // fetch the newly wired virtual-device. Use the external-id as search param
                  // params in order FYI: context, userId, scopeIds, filters, options, orderBy, offset, limit
                  ApiService.virtualDeviceFetch(this, null, [], [], null, null, 0, 1, [{
                    variable: 'deviceId',
                    search: virtualDeviceOptions.id
                  }]));
                }

                if (this.vDeviceFetchMapping['vdeviceOrgState'][virtualDeviceOptions.stateId]) {
                  promisesPhase1.push(Promise.resolve(this.vDeviceFetchMapping['vdeviceOrgState'][virtualDeviceOptions.stateId]));
                } else {
                  promisesPhase1.push( // to match the newly wired vdevice with the current one, fetch the ORIGINAL state,
                  // then pick the state with the same key from the list just above
                  ApiService.digitalTwinGetState(this, virtualDeviceOptions.stateId));
                } // -------------
                // FETCH PHASE I


                return _context.abrupt("return", Promise.all(promisesPhase1).then(function (res) {
                  var vDeviceMatches = res[0];
                  var orgState = res[1] || {};
                  _this7.vDeviceFetchMapping['vdevice'][virtualDeviceOptions.id] = vDeviceMatches;
                  _this7.vDeviceFetchMapping['vdeviceOrgState'][virtualDeviceOptions.stateId] = orgState;

                  if (vDeviceMatches.totalCount > 1) {
                    // more than 1 match was found, cannot use this v-device
                    return {
                      id: vDeviceLookupMultipleMatches,
                      title: null
                    };
                  } else if (vDeviceMatches.totalCount === 0) {
                    throw new Error('NIOTA_DEVICE_NOT_FOUND');
                  }

                  var matchedVDeviceId = vDeviceMatches.virtualDevices[0].id;
                  var promisesPhase2 = [Promise.resolve(vDeviceMatches), Promise.resolve(orgState)];

                  if (_this7.vDeviceFetchMapping['vdeviceStates'][matchedVDeviceId]) {
                    promisesPhase2.push(Promise.resolve(_this7.vDeviceFetchMapping['vdeviceStates'][matchedVDeviceId]));
                  } else {
                    promisesPhase2.push( // fetch the states on the newly wired virtual-device
                    ApiService.digitalTwinFetchStates(_this7, matchedVDeviceId));
                  } // -------------
                  // FETCH PHASE II


                  return Promise.all(promisesPhase2);
                }).then(function (res) {
                  if (res.constructor === Object && res.id === vDeviceLookupMultipleMatches) {
                    return res;
                  }

                  var vDeviceMatch = res[0];
                  var orgState = res[1] || {};
                  var newStates = res[2];
                  var matchedVDevice = vDeviceMatch.virtualDevices[0];
                  _this7.vDeviceFetchMapping['vdeviceStates'][matchedVDevice.id] = newStates;

                  if (!newStates) {
                    throw new Error('NIOTA_DEVICE_NOT_FOUND');
                  }

                  return {
                    id: matchedVDevice.id,
                    title: matchedVDevice.title,
                    stateId: (newStates.find(function (s) {
                      return s.key === orgState.key;
                    }) || {}).id,
                    key: (newStates.find(function (s) {
                      return s.key === orgState.key;
                    }) || {}).key
                  };
                }).catch(function (error) {
                  console.error(error);
                  var errorMessage = get(error, 'response.data.message', error.message);
                  var errorOutput = _this7.$i18n_te("Error.".concat(errorMessage)) ? _this7.$i18n_t("Error.".concat(errorMessage)) : _this7.$i18n_t(errorMessage);

                  _this7.$snack(errorOutput, 'error');

                  return {
                    id: null,
                    title: "".concat(virtualDeviceOptions.id, " ").concat(_this7.$i18n_t('NiotaClassic.Devices.snacks.notFound')),
                    key: null
                  };
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchVirtualDeviceDataDetails(_x) {
        return _fetchVirtualDeviceDataDetails.apply(this, arguments);
      }

      return fetchVirtualDeviceDataDetails;
    }()
  })
};